import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { CreditCard, Loader2, LogOut, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PaymentPendingGate = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const pay = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/auth/registration-payment/session`,
        { origin_url: window.location.origin },
        { withCredentials: true }
      );
      window.location.href = res.data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo iniciar el pago. Inténtalo de nuevo.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="payment-pending-gate">
      <Card className="card-elevated max-w-md w-full">
        <CardContent className="py-10 text-center space-y-5">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
            <CreditCard className="w-8 h-8 text-amber-600" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold">Completa tu pago para empezar</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Hola {user?.first_name || user?.name}, tu cuenta está creada pero falta el pago
              de tu libro para activarla.
            </p>
          </div>
          {user?.payment_amount_eur != null && (
            <div className="rounded-lg border border-amber-200 bg-amber-50/60 px-4 py-3 text-sm">
              <span className="text-muted-foreground">Importe pendiente: </span>
              <strong data-testid="pending-amount">{Number(user.payment_amount_eur).toFixed(2)}€</strong>
              <span className="text-muted-foreground"> (libro base + IVA, envío en España incluido)</span>
            </div>
          )}
          <Button onClick={pay} disabled={loading} className="w-full gap-2 btn-primary" data-testid="complete-payment-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />}
            Completar pago con tarjeta
          </Button>
          <p className="flex items-center justify-center gap-1.5 text-[11px] text-muted-foreground">
            <ShieldCheck className="w-3.5 h-3.5" />
            Pago seguro procesado por Stripe
          </p>
          <button
            type="button"
            onClick={logout}
            className="text-xs text-muted-foreground underline hover:text-foreground inline-flex items-center gap-1"
            data-testid="gate-logout-btn"
          >
            <LogOut className="w-3 h-3" />
            Cerrar sesión
          </button>
        </CardContent>
      </Card>
    </div>
  );
};
